export default {
  pageTitle: "共通情報設定",
  description: "説明",
  value: "値",
  gradeLabel: "グレード段階数",
  session: "評価期間",
  gradeUnit: "レベル",
  day: "日",
  timeAlertReview: "評価決定できる時点から",
  maxTargetScore: "最大実績",
  messageNotification:
    "評価期間の編集内容を保存すると、行っていない設定済み目標が削除されますが、本当に保存しますか？",
  canViewPeers: "社員のコミットメント\n閲覧設定",
  hrDepartment: "人事部設定",
  meetingManagement: "経営会議\n評価者設定",
  department: "部署",
  departmentCode: "部署コード",
  position: "役職",
  positionCode: "役職コード",
  positionName: "役職名",
  searchPositionCode: "役職コードを入力していください。",
  accepted: "閲覧できる",
  denied: "閲覧できない",
  dialog: {
    cyclePrefix: "年",
    cycleSuffix: "回",
  },
  hrDepartmentDialog: {
    id: "部署コード",
    departmentName: "部署名",
    searchDepartmentLabel: "部署コードや部署名を入力していください。",
    confirmationTitle: "人事部設定確認",
    confirmationDescription:
      "選択した部署と役職が共通設定に反映されますが、よろしいですか？",
  },
  noAssessmentConfig: "設定はありません。",
  searchDepartmentId: "部署コードを入力していください。",
};
